import { render, staticRenderFns } from "./UnidadeMedidaManage.vue?vue&type=template&id=df68554c&scoped=true"
import script from "./UnidadeMedidaManage.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaManage.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaManage.vue?vue&type=style&index=0&id=df68554c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df68554c",
  null
  
)

export default component.exports